import React, { useEffect, useState } from 'react';
import { DownIcon } from '../Global/Icons';
import { FadeTable, FadeModal, TableLink, ActiveToggle } from '../Global/Transitions';
import Tests from '../../Models/Tests';
import ProjectsRow from './Rows/ProjectsRow';
import EditProject from '../Popups/EditProject';
import UsersPagination from '../Users/UsersPagination';
import { useUser } from '../Global/RoleContext';
import { canViewerOpenProject } from '../../Utilities/AccessControl';






interface ProjectsListProps {
  tests: Tests[];
  projectIds: { [testId: string]: number | null };
  projectStatuses: { [testId: string]: string | null };
  loading: boolean;
  OnProjectChange: () => void;
}

const ProjectsList: React.FC<ProjectsListProps> = ({ tests, projectIds, projectStatuses, loading, OnProjectChange }) => {
  const [show, setShow] = useState(false);
  const [toggle, setToggle] = useState(1);
  const [page, setPage] = useState(1);
  const pageSize = 7;
  const onChange = (value) => { setToggle(value); setPage(1); };
  const [complete, setComplete] = useState(false);
  const [sort] = useState({ key: '_ts', ascending: true });
  tests.sort((a, b) => (b[sort.key] || 0) - (a[sort.key] || 0));
  const handleHide = () => { setShow(false); OnProjectChange(); };
  const handleComplete = () => { setComplete(true); OnProjectChange(); };
  const handleShow = () => { setComplete(false); setShow(true) };
  const filtered = tests.filter(test => (toggle !== 1) === (test.status === 'Closed'));
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const paged = filtered.slice((page - 1) * pageSize, page * pageSize);

  // Keep the current page valid if the list shrinks (toggle switch / data refresh).
  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);

  const { highestPrivilegeRole, myApplicationRole } = useUser();
  const IsViewer = highestPrivilegeRole === "Project Viewer";




  if (loading) {
    return <div style={{ textAlign: 'center', padding: '40px' }}>Loading projects...</div>;
  }
  return (
    <FadeTable>
      <thead>
        <tr>
          <th colSpan={3}><h2>Projects</h2></th>
          <th colSpan={5} className='py-0 align-content-center'><ActiveToggle toggle={toggle} onChange={onChange} /></th>
        </tr>
      </thead>
      <thead className='bg-lighter'>
        <tr>
          <th>Name</th>
          <th style={{ minWidth: 180 }}>Status</th>
          <th style={{ minWidth: 142 }}>Project Owner</th>
          <th style={{ minWidth: 145 }}>Last Updated<DownIcon /></th>
          <th>Progress</th>
          <th colSpan={3} />
        </tr>
      </thead>
      <tbody>
        {filtered.length === 0 ? (<tr>
          <td colSpan={8} style={{ textAlign: 'center', padding: '20px' }}>
            No projects available.
          </td>
        </tr>
        ) : (
          paged.map(test => {
            const matchingRole = myApplicationRole?.find(
              role => role.id === test.ticketno
            );
            const userrole = matchingRole ? matchingRole.role : null;
            const isProjectViewer = userrole === 'Project Viewer';
            // Only pass projectId for scheduled tests
            const projectId = projectIds[test.id] ?? null;
            const canOpen = !isProjectViewer || canViewerOpenProject(test.status, projectId);
            return (
              <ProjectsRow
                key={test.id}
                test={test}
                userrole={userrole}
                canOpen={canOpen}
                projectId={projectId}
                projectStatus={projectStatuses[test.id] ?? null}
                OnProjectChange={OnProjectChange}
              />
            );
          })
        )}
        
        {!IsViewer &&
          <><TableLink onClick={handleShow}>Create New Project</TableLink>
          <FadeModal show={show} onHide={handleHide} title={complete ? '' : 'New Project'}>
            <EditProject action='create' close={handleHide} complete={handleComplete} />
          </FadeModal></>
        }
        {totalPages > 1 && (
          <tr>
            <td colSpan={8} className="p-0">
              <UsersPagination total={filtered.length} page={page} pageSize={pageSize} onPageChange={setPage} />
            </td>
          </tr>
        )}
      </tbody>
    </FadeTable>
  );
};

export default ProjectsList;